const page = $(document);

page.on("click", "[data-trigger]", function (e) {
  const element = $(e.target);
  const action = $(`${element.data("trigger")}`);
  const notify = $(`${element.data("notify")}`);
  element.toggleClass("active");
  const active = element.hasClass("active");
  notify.toggleClass("active", active);
  const groupId = element.data("group");
  const minHeight = action.data("min-height");

  if (groupId != null) {
    const group = $(`[data-group=${groupId}]`);
    group.each(function (i, node) {
      //close all elements in the same group
      const content = $(node);
      if (node !== element.get(0) && content.hasClass("active") && active) {
        content.click();
      }
    });
  }

  if (element.data("animation") === "none") {
    action.toggle();
    return;
  }

  if (minHeight != null) {
    if (active) {
      action.animate({
        height: action.get(0).scrollHeight,
      });
    } else {
      action.animate({
        height: minHeight,
      });
    }
  } else {
    action.slideToggle();
  }
});

page.on("click", "[data-overlay]", function (e) {
  e.preventDefault();
  const element = $(e.target);
  const overlay = $(`${element.data("overlay")}`);
  const blind = overlay.parent().find(".overlay-blind");
  element.addClass("active");
  overlay.slideDown();
  blind.fadeIn();
  scrollTo(overlay);
});

page.on("click", "[data-close]", function (e) {
  e.preventDefault();
  const element = $(e.target);
  const selector = element.data("close");
  console.log(selector);
  const overlay = $(`${selector}`);
  const blind = overlay.parent().find(".overlay-blind");
  const buttons = $(`[data-overlay=\"${selector}\"]`);
  buttons.removeClass("active");
  overlay.slideUp();
  overlay.fadeOut();
  blind.fadeOut();
});

page.on("click tap", "[data-focus]", function (e) {
  e.preventDefault();
  const element = $(e.target);
  const focus = $(`${element.data("focus")}`);
  if (focus.is(":focus")) {
    focus.blur();
  } else {
    focus.focus();
  }
});

page.on("ready turbo:load", function () {
  $("[data-trigger]").each(function () {
    const element = $(this);
    const action = $(`${element.data("trigger")}`);
    const minHeight = action.data("min-height");
    if (!element.hasClass("active")) {
      if (minHeight != null) {
        action.css({ height: minHeight });
      } else {
        action.hide();
      }
    }
  });

  $("[data-overlay]").each(function () {
    const element = $(this);
    const selector = element.data("overlay");
    const overlay = $(`${selector}`);
    overlay
      .parent()
      .append(
        $(`<div class=\"overlay-blind\" data-close=\"${selector}\"></div>`),
      );
    if (!element.hasClass("active")) {
      overlay.parent().children().hide();
    }
  });

  $("form.js-autosubmit").submit();
});

function scrollTo(element) {
  if (!element) return;
  $("body").animate({ scrollTop: element.offset().top - 10 });
}
